import { render } from "./OdKeyValueList.vue?vue&type=template&id=432e0b32"
import script from "./OdKeyValueList.vue?vue&type=script&lang=js"
export * from "./OdKeyValueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__